import { render, staticRenderFns } from "./ByFormItem.vue?vue&type=template&id=77a6940c&scoped=true"
import script from "./ByFormItem.vue?vue&type=script&lang=js"
export * from "./ByFormItem.vue?vue&type=script&lang=js"
import style0 from "./ByFormItem.vue?vue&type=style&index=0&id=77a6940c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a6940c",
  null
  
)

export default component.exports